<!--
动画流程:
1. slide 平均每 5s 切换一次, 每一次以 1s 淡入淡出的动画方式完成切换动作
2. 每次完成 slide 切换后, 形象图(img) 以 5s 的速度从右向左完成 60px 位移
-->
<template>
  <base-swiper
    :data="banners"
    :speed="1000"
    :autoplay="autoplay"
    fade
    :class="$style.swiper"
  >
    <template v-slot:default="slotProps">
      <img :src="slotProps.el.bg" />
      <img :src="slotProps.el.img" />
    </template>
  </base-swiper>
</template>

<script>
import BaseSwiper from '../BaseSwiper'

export default {
  components: { BaseSwiper },
  data() {
    return {
      banners: [
        {
          img: require('./images/company-illus-img1.png'),
          bg: require('./images/company-illus-bg1.png'),
        },
        {
          img: require('./images/company-illus-img2.png'),
          bg: require('./images/company-illus-bg2.png'),
        },
      ],
      autoplay: { delay: 5000 },
    }
  },
}
</script>

<style lang="less" module>
.swiper {
  .size(11.88rem, 10.53rem);

  img {
    .size(100%);
    position: absolute;
    top: 0;
    left: 0;
  }

  :global(.swiper-slide-active) img:last-child {
    animation: fadeInImg 5s;
  }
}

@keyframes fadeInImg {
  from {
    transform: translate3d(0.6rem, 0, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}
</style>
